import * as Yup from "yup";

export const updatePasswordSchema = Yup.object({
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[0-9]/, "Password must include at least one number")
    .matches(/[A-Z]/, "Password must include at least one uppercase letter")
    .matches(/[a-z]/, "Password must include at least one lowercase letter")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must include at least one special character"
    ),
});

export const updateSubjectsSchema = Yup.object({
  subjects: Yup.array()
    .of(Yup.string())
    .min(1, "Please select at least one subject"),
});

export const addUserSchema = Yup.object().shape({
  mode: Yup.string().oneOf(["parent", "learner"]).required(),

  // parent fields
  parentFirstName: Yup.string().when("mode", {
    is: "parent",
    then: (s) => s.required("First name is required"),
    otherwise: (s) => s.notRequired(),
  }),
  parentLastName: Yup.string().when("mode", {
    is: "parent",
    then: (s) => s.required("Last name is required"),
    otherwise: (s) => s.notRequired(),
  }),
  parentEmail: Yup.string().when("mode", {
    is: "parent",
    then: (s) => s.email("Invalid email").required("Email is required"),
    otherwise: (s) => s.notRequired(),
  }),
  parentPassword: Yup.string().when("mode", {
    is: "parent",
    then: (s) =>
      s
        .required("Password is required")
        .min(8, "Password is too short - must be at least 8 chars")
        .matches(/[0-9]/, "Password must contain a number")
        .matches(/[A-Za-z]/, "Password must contain a letter"),
    otherwise: (s) => s.notRequired(),
  }),
  parentPhone: Yup.string().when("mode", {
    is: "parent",
    then: (s) =>
      s
        .required("Phone is required")
        .matches(
          /^[689]\d{7}$/,
          "Phone number must be 8 digits and start with 6, 8, or 9"
        ),
    otherwise: (s) => s.notRequired(),
  }),

  // learner fields
  firstName: Yup.string().when("mode", {
    is: "learner",
    then: (s) => s.required("First name is required"),
    otherwise: (s) => s.notRequired(),
  }),
  lastName: Yup.string().when("mode", {
    is: "learner",
    then: (s) => s.required("Last name is required"),
    otherwise: (s) => s.notRequired(),
  }),
  username: Yup.string().when("mode", {
    is: "learner",
    then: (s) => s.required("Username is required"),
    otherwise: (s) => s.notRequired(),
  }),
  password: Yup.string().when("mode", {
    is: "learner",
    then: (s) =>
      s
        .required("Password is required")
        .min(8, "Password is too short - must be at least 8 chars")
        .matches(/[0-9]/, "Password must contain a number")
        .matches(/[A-Za-z]/, "Password must contain a letter"),
    otherwise: (s) => s.notRequired(),
  }),
  level: Yup.string().when("mode", {
    is: "learner",
    then: (s) => s.required("Level is required"),
    otherwise: (s) => s.notRequired(),
  }),
  parent_id: Yup.string().when("mode", {
    is: "learner",
    then: (s) => s.required("Parent selection is required"),
    otherwise: (s) => s.notRequired(),
  }),
  subjects: Yup.array()
    .of(Yup.string())
    .when("mode", {
      is: "learner",
      then: (s) => s.min(1, "Please select at least one subject"),
      otherwise: (s) => s.notRequired(),
    }),
  year: Yup.string().notRequired(),
  school: Yup.string().when("mode", {
    is: "learner",
    then: (s) => s.required("School is required"),
    otherwise: (s) => s.notRequired(),
  }),
});
